module.exports = __webpack_public_path__ + "static/media/ic_arrow_down_gray.0a771506.svg";